/* export module util {
    function isNullOrUndefined<T>(obj: T | null | undefined): obj is null | undefined {
      return typeof obj === 'undefined' || obj === null;
    }
} */

export function isNullOrUndefined<T>(obj: T | null | undefined): obj is null | undefined {
  return typeof obj === 'undefined' || obj === null;
}

export function isArray(object: any): object is any[] {
  return Array.isArray(object);
};

export function isObject(object: any): boolean {
  return (typeof object !== 'object' && typeof object !== 'function') || object === null;
}

/* export function isNullOrUndefined(value: any) {
    return value === null || value === undefined;
} */
